var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "level" },
        [
          _c(
            "Header",
            _vm._b(
              { staticClass: "level-left" },
              "Header",
              _vm.$route.meta,
              false
            )
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-field",
              { attrs: { grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Date" } },
                  [
                    _c("b-datepicker", {
                      attrs: {
                        name: "date",
                        "first-day-of-week": 1,
                        locale: "en-CA",
                        icon: "calendar-alt",
                        placeholder: "Date",
                      },
                      model: {
                        value: _vm.date,
                        callback: function ($$v) {
                          _vm.date = $$v
                        },
                        expression: "date",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Region" } },
                  [
                    _c("multiselect", {
                      staticStyle: { "min-width": "400px" },
                      attrs: {
                        options: _vm.regions,
                        multiple: true,
                        label: "name",
                        "track-by": "name",
                        "close-on-select": false,
                        placeholder: "Pick region",
                      },
                      model: {
                        value: _vm.selectedRegion,
                        callback: function ($$v) {
                          _vm.selectedRegion = $$v
                        },
                        expression: "selectedRegion",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Country" } },
                  [
                    _c("multiselect", {
                      staticStyle: { "min-width": "400px" },
                      attrs: {
                        options: _vm.countries,
                        multiple: true,
                        "close-on-select": false,
                        placeholder: "Pick country",
                      },
                      model: {
                        value: _vm.selectedCountry,
                        callback: function ($$v) {
                          _vm.selectedCountry = $$v
                        },
                        expression: "selectedCountry",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-field",
              [
                _c(
                  "b-button",
                  {
                    staticClass: "left-right",
                    attrs: {
                      type: "is-warning",
                      "icon-left": "arrows-rotate",
                      disabled: _vm.isLoading,
                    },
                    on: {
                      click: () => {
                        _vm.resetData()
                        _vm.getData()
                      },
                    },
                  },
                  [_vm._v(" Load ")]
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "left-right ml-3",
                    attrs: {
                      type: "is-success",
                      "icon-left": "download",
                      disabled: !_vm.isLoaded || _vm.isLoading,
                    },
                    on: {
                      click: () => {
                        _vm.exportToExcel()
                      },
                    },
                  },
                  [_vm._v(" Export xlsx ")]
                ),
              ],
              1
            ),
            _vm._l(_vm.stocks, function (plant) {
              return _c(
                "div",
                {
                  key: plant.id_site,
                  staticClass: "card",
                  style: {
                    padding: "1rem",
                    "margin-bottom": "1rem",
                  },
                },
                [
                  _c("div", [
                    _vm._v(
                      " " + _vm._s(plant.name + " " + plant.id_site) + " "
                    ),
                  ]),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-2" }, [
                      _c("div", [_vm._v(" GPS 5 Stocks ")]),
                      _c("div", [
                        _vm._v(" " + _vm._s("Clean: " + plant.clean5) + " "),
                      ]),
                      _c("div", [
                        _vm._v(" " + _vm._s("Dirty: " + plant.dirty5) + " "),
                      ]),
                      _c("div", [
                        _vm._v(" " + _vm._s("Repair: " + plant.repair5) + " "),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-2" }, [
                      _c("div", [_vm._v(" GPS 1 Stocks ")]),
                      _c("div", [
                        _vm._v(" " + _vm._s("Clean: " + plant.clean1) + " "),
                      ]),
                      _c("div", [
                        _vm._v(" " + _vm._s("Dirty: " + plant.dirty1) + " "),
                      ]),
                      _c("div", [
                        _vm._v(" " + _vm._s("Repair: " + plant.repair1) + " "),
                      ]),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", [_vm._v(" Safety Stocks ")]),
                      _c(
                        "table",
                        {
                          staticStyle: {
                            "border-collapse": "separate",
                            "border-spacing": "1rem 0",
                          },
                        },
                        [
                          _vm._m(0, true),
                          _c("tr", [
                            _c("td", [_vm._v(" Available: ")]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.min_available) + " "),
                            ]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.available) + " "),
                            ]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    plant.min_available &&
                                      plant.min_available !== 0
                                      ? (
                                          (plant.available /
                                            plant.min_available) *
                                          100
                                        ).toFixed(0) + "%"
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v(" Clean: ")]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.min_clean) + " "),
                            ]),
                            _c("td", [_vm._v(" " + _vm._s(plant.clean) + " ")]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    plant.min_clean && plant.min_clean !== 0
                                      ? (
                                          (plant.clean / plant.min_clean) *
                                          100
                                        ).toFixed(0) + "%"
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v(" Dirty: ")]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.min_dirty) + " "),
                            ]),
                            _c("td", [_vm._v(" " + _vm._s(plant.dirty) + " ")]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    plant.min_dirty && plant.min_dirty !== 0
                                      ? (
                                          (plant.dirty / plant.min_dirty) *
                                          100
                                        ).toFixed(0) + "%"
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v(" Repair: ")]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.min_repair) + " "),
                            ]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.repair) + " "),
                            ]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    plant.min_repair && plant.min_repair !== 0
                                      ? (
                                          (plant.repair / plant.min_repair) *
                                          100
                                        ).toFixed(0) + "%"
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", [_vm._v(" Max Stocks ")]),
                      _c(
                        "table",
                        {
                          staticStyle: {
                            "border-collapse": "separate",
                            "border-spacing": "1rem 0",
                          },
                        },
                        [
                          _vm._m(1, true),
                          _c("tr", [
                            _c("td", [_vm._v(" " + _vm._s("Clean: ") + " ")]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.max_clean) + " "),
                            ]),
                            _c("td", [_vm._v(" " + _vm._s(plant.clean) + " ")]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    plant.max_clean && plant.max_clean !== 0
                                      ? (
                                          (plant.clean / plant.max_clean) *
                                          100
                                        ).toFixed(0) + "%"
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v(" " + _vm._s("Dirty: ") + " ")]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.max_dirty) + " "),
                            ]),
                            _c("td", [_vm._v(" " + _vm._s(plant.dirty) + " ")]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    plant.max_dirty && plant.max_dirty !== 0
                                      ? (
                                          (plant.dirty / plant.max_dirty) *
                                          100
                                        ).toFixed(0) + "%"
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v(" " + _vm._s("Total: ") + " ")]),
                            _c("td", [
                              _vm._v(" " + _vm._s(plant.max_total) + " "),
                            ]),
                            _c("td", [_vm._v(" " + _vm._s(plant.total) + " ")]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    plant.max_total && plant.max_total !== 0
                                      ? (
                                          (plant.total / plant.max_total) *
                                          100
                                        ).toFixed(0) + "%"
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", [_vm._v(" Status ")]),
      _c("td", [_vm._v(" Safety ")]),
      _c("td", [_vm._v(" Current ")]),
      _c("td", [_vm._v(" % ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", [_vm._v(" Status ")]),
      _c("td", [_vm._v(" Max ")]),
      _c("td", [_vm._v(" Current ")]),
      _c("td", [_vm._v(" % ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }